<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card class="elevation-12 text-center pa-8">
          <v-icon size="100" color="success" class="mb-4">
            mdi-check-circle
          </v-icon>

          <v-card-title class="justify-center text-h4 success--text">
            Sucesso!
          </v-card-title>

          <v-card-text class="text-h6 mt-4">
            Sua transação foi efetuada com sucesso.
          </v-card-text>

          <v-card-actions class="justify-center mt-6">
            <v-btn color="primary" large to="/inicio">
              <v-icon left>mdi-home</v-icon>
              Voltar ao início
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Sucesso",
};
</script>
